// ui/components/VisitasTable.jsx  (presentacional: props in, callbacks out; sin efectos ni Api)
import React from 'react';
import NoPagination from '../../../../../components/pagination/noPagination.jsx';
import getBackgroundColor from '../../../../../utils/getBackgroundColor.js';
import getColor from '../../../../../utils/getColor.js';
import { editLinkCell, selectionColumn } from '../../../shared/ui/listColumns.jsx';

// detailPath(visita) y productorPath(visita) devuelven la ruta del enlace verde (productorPath puede ser '' => texto).
const VisitasTable = ({ data, blocking, selectedUuid, onSelect, detailPath, productorPath }) => {
  const columns = React.useMemo(
    () => [
      {
        // Un único grupo: NoPagination pinta la barra de título oscura y la fila de encabezados beige.
        Header: 'VISITAS',
        columns: [
          selectionColumn({ selectedUuid, onSelect }),
          { Header: 'FECHA', accessor: 'fecha', sortable: true, minWidth: 110 },
          { Header: 'MOTIVO', accessor: 'motivo', sortable: true, Cell: editLinkCell(detailPath) },
          { Header: 'PRODUCTOR', accessor: 'productor_nombre', sortable: true, Cell: editLinkCell(productorPath) },
          { Header: 'PARCELA', accessor: 'parcela_nombre', sortable: true },
          { Header: 'RESPONSABLE', accessor: 'responsable_nombre', sortable: true },
        ],
      },
    ],
    [selectedUuid, onSelect, detailPath, productorPath]
  );

  return <NoPagination blocking={blocking} columns={columns} data={data} fnBackgroundColor={getBackgroundColor} fnColor={getColor} />;
};

export default VisitasTable;
